
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/consent/onetrust",
      function () {
        return require("private-next-pages/events/consent/onetrust.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/consent/onetrust"])
      });
    }
  